import Vue from 'vue'
import VueRouter from 'vue-router'

//utils
import AuthApi from '../scripts/AuthApi.js'
import UserService from '../scripts/UserService.js'
import VersionChecker from '../scripts/VersionChecker.js'
import SubscriptionStore from '../scripts/SubscriptionStore';

//views
import SleepView from '../views/SleepView.vue'
import SubscriptionsView from '../views/SubscriptionsView.vue'
import FeedsView from '../views/FeedsView.vue'

const store = new SubscriptionStore();

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: SubscriptionsView,
    props: { store: store }
  },
  {
    path: '/feeds',
    name: 'Feeds',
    component: FeedsView,
  },
   {
     path: '/sleep',
     name: 'Sleep',
     component: SleepView
   }
]

const router = new VueRouter({
  routes
});

const userService = new UserService();
const authApi = new AuthApi();
const versionChecker = new VersionChecker();

router.beforeEach(async (to, from, next) => {
  let authInfo = await authApi.getAuthInfo();

  if (!authInfo) {
    userService.clearUser();
    window.location = 'rss/api/v3/auth/login';
    return;
  }

  if(!userService.getLoggedInUser()) {
    userService.setLoggedInUser(authInfo.username, authInfo.permissions);
  }

  versionChecker.ensureCorrectVersion();

  next();
})

export default router
